import { RepostCountModel } from "./../views/private/timeline/models/repostcount.model";
import { CommentCountModel } from "./../views/private/timeline/models/commentcount.model";
import httpService from "@/services/http.service";
import storageService from "@/services/storage.service";
import utilService from "@/services/util.service";
import PostsModel, { PostDomain } from "@/views/private/timeline/models/posts.model";
import {
  collection,
  getDocs,
  getFirestore,
  limit,
  onSnapshot,
  orderBy,
  query,
  startAfter,
  Unsubscribe,
  where,
} from "firebase/firestore";
import { ref } from "vue";
import { ReactionCountModel } from "@/views/private/timeline/models/reactioncount.model";
import PollCountModel from "@/views/private/timeline/models/pollcount.model";
import { ActivityDataModel, ActivityType, } from "@/views/private/timeline/models/activitydata.model";
import { usePosts } from "@/views/private/timeline/composables/posts.composables";
import { useReactionStore } from "@/services/reaction.store";
import UpdatePostModel from "@/views/private/timeline/models/updatepost.model";
import { trackError, trackEvent } from "@/helpers/tracking.helpers";
import { TrackingEvents } from "@/helpers/enum";
import { useI18n } from "vue-i18n";

let unSubscribe: Unsubscribe;
let unsubscribeReactions: Unsubscribe;
const unsubscribeFeedId = ref<string>();
const startAfterSnapshot = ref<any>();
const pageLimit = 50;
const noDataFound = ref<boolean>(false);
const currentPage = ref<number>(1);
const posts = ref<PostsModel[]>([]);
const stockName = ref<any>();

export const useStockPost = () => {

  let timeout;
  const reactionCount = ref<ReactionCountModel[]>([]);
  const commentCount = ref<CommentCountModel[]>([]);
  const repostCount = ref<RepostCountModel[]>([]);
  const pollCount = ref<PollCountModel[]>([]);
  let showLoader = ref(false);
  const { getPostById } = usePosts();
  const reactionStore = useReactionStore();
  const { t } = useI18n();

  const initReactionListenersForLoadedPosts = (feedId: string) => {
    const postIds = posts.value
      .map((post) => post._id)
      .filter((id): id is string => !!id);

    if (postIds.length > 0) {
      reactionStore.initReactionListenersForPosts(feedId, postIds);
    }
  };
  const addPostToFeeding = async (addPostDTO: PostsModel) => {
    return new Promise((resolve, reject) => {
      httpService
        .addPost(addPostDTO)
        .then((response) => {
          if (response.data.isSuccess) {
            trackEvent(TrackingEvents.postSharedSuccessfully, {
              postId: response.data.data._id,
              postType: addPostDTO.type
            });
            let activity = new ActivityDataModel();
            activity.type = ActivityType.post;
            activity.data = response.data.data;
            activity.data.domain = PostDomain.stock;
            addPostsToFeed(activity, "added", true);
            addPostToStockCollections(response.data.data._id);
            resolve(true);
            trackEvent(TrackingEvents.postSharedSuccessfully, {
              postId: response.data.data._id,
              postType: addPostDTO.type
            });
            utilService.showToast(t("common.toast.successPostShared"));
          }
          resolve(false);
        })
        .catch((err) => {
          trackError(TrackingEvents.postSharedSuccessfully, {
            postId: addPostDTO._id,
            error: err.message
          });
          reject(err);
        });
    });
  };

  const getDb = () => {
    const db = getFirestore();
    return db;
  };

  const addPost = async (addPostDTO: PostsModel) => {
    const response = await httpService.addPost(addPostDTO);
    if (response.data.isSuccess) {
      let activity = new ActivityDataModel();
      activity.type = ActivityType.post;
      activity.data = response.data.data;
      addPostsToFeed(activity, "added");
      // posts.value.splice(0, 0, activity.data)
      utilService.showToast("Post Added Successfully.");
      return true;
    }
    return false;
  };

  const updatePost = async (updatePostDTO: UpdatePostModel) => {
    const response = await httpService.updatePost(updatePostDTO);
    if (response.data.isSuccess) {
      utilService.showToast("Post Added Successfully.");
    }
  };

  const deletePost = async (id: string) => {
    let payload = {
      postId: id,
    };
    const response = await httpService.deletePost(payload);
    if (response.data.isSuccess) {
      posts.value = posts.value.filter((x) => x._id != id);
      utilService.showToast("Post Deleted Successfully.");
    }
  };

  const getPosts = async (stock: string, page: number) => {
    if (page === 1) {
      startAfterSnapshot.value = null;
      posts.value = [];
      noDataFound.value = true;
    }
    const db = getDb();
    if (stock.includes("$")) {
      stock = stock.replaceAll("$", "");
    }
    const feedId = "$" + stock;
    stockName.value = feedId;
    try {
      // Build query with pagination
      let baseQuery: any = query(
        collection(db, "feeds", feedId, "activities"),
      );
      // Add pagination
      let paginatedQuery: any;
      if (startAfterSnapshot.value) {
        paginatedQuery = query(
          baseQuery,
          limit(pageLimit),
          orderBy("data.modifiedOn", "desc"),
          startAfter(startAfterSnapshot.value)
        );
      } else {
        paginatedQuery = query(
          baseQuery,
          limit(pageLimit),
          orderBy("data.modifiedOn", "desc"),
        );
      }

      const querySnapshot = await getDocs(query(
        paginatedQuery,
      ));
      utilService.updateReadCount();
      if (querySnapshot.empty) {
        noDataFound.value = true;
      } else {
        currentPage.value = page;
        noDataFound.value = false;
        startAfterSnapshot.value = querySnapshot.docs[querySnapshot.docs.length - 1];
        querySnapshot.docs.forEach((doc: any) => {
          const activityData: ActivityDataModel = doc.data() as ActivityDataModel;
          if (activityData.type === "post") {
            addPostsToFeed(
              activityData,
              "added",
              false
            );
          }
        });
        initReactionListenersForLoadedPosts(feedId);
      }
      listenPost(feedId, baseQuery);
    } catch (error) {
      console.error("Error in getPosts:", error);
    }
  };

  const listenPost = async (feedId: string, postQuery: any) => {
    if (unsubscribeFeedId.value == feedId) {
      return;
    }
    unsubscribeFeedId.value = feedId;
    if (unsubscribeReactions) {
      unsubscribeReactions();
    }
    if (unSubscribe) {
      unSubscribe();
    }
    const q = query(
      postQuery,
      where("type", "!=", "post")
    );
    unsubscribeReactions = onSnapshot(q, (querySnapshot) => {
      utilService.updateReadCount();
      querySnapshot.docChanges().forEach((doc) => {
        try {
          const activityData: ActivityDataModel =
            doc.doc.data() as ActivityDataModel;
          if (activityData.type === "reaction-count") {
            addReactionCountToFeed(activityData, doc.type);
          } else if (activityData.type === "comment-count") {
            addCommentCount(activityData, doc.type);
          } else if (activityData.type === "repost-count") {
            addRepostCount(activityData, doc.type);
          } else if (activityData.type === "poll-chart-count") {
            addPollCount(activityData, doc.type);
          }
        } catch (e) { }
      });
    });
    const currentDate = new Date();
    const initialDate = currentDate.setHours(currentDate.getHours() - 24);
    unSubscribe = onSnapshot(query(
      postQuery,
      where("type", "==", "post"),
      where("data.modifiedOn", ">=", initialDate),
    ), (querySnapshot) => {
      utilService.updateReadCount();
      querySnapshot.docChanges().forEach((doc) => {
        try {
          const activityData: ActivityDataModel =
            doc.doc.data() as ActivityDataModel;
          if (activityData.type === "post") {
            addPostsToFeed(
              activityData,
              "added",
              false
            );
          }
        } catch (e) { }
      });
    });
  };

  const clearPosts = () => {
    unSubscribe();
    posts.value = [];
    commentCount.value = [];
    reactionCount.value = [];
    repostCount.value = [];
    // myPosts.value = [];
  };

  const addPollCount = (
    activityData: ActivityDataModel,
    firebaseUpdateType: string
  ) => {
    let tempPollCountModel = new PollCountModel();
    Object.assign(tempPollCountModel, activityData.data);
    if (firebaseUpdateType === "added" || firebaseUpdateType === "modified") {
      let index = pollCount.value.findIndex(
        (x) => x.postId === tempPollCountModel.postId
      );
      if (index === -1) {
        pollCount.value.push(tempPollCountModel);
      } else {
        pollCount.value[index] = { ...tempPollCountModel };
      }
    } else {
      let index = pollCount.value.findIndex(
        (x) => x.postId === tempPollCountModel.postId
      );
      if (index !== -1) {
        pollCount.value.splice(index, 1);
      }
    }
  };

  const addCommentCount = (
    activityData: ActivityDataModel,
    firebaseUpdateType: string
  ) => {
    let tempCommentCount = new CommentCountModel();
    Object.assign(tempCommentCount, activityData.data);
    tempCommentCount._id = activityData.data._id;
    if (firebaseUpdateType === "added") {
      commentCount.value.push(tempCommentCount);
    } else if (firebaseUpdateType === "modified") {
      let index = commentCount.value.findIndex(
        (x) =>
          x.sourceId === tempCommentCount.sourceId &&
          x.sourceType === tempCommentCount.sourceType
      );
      if (index !== -1) {
        Object.assign(commentCount.value[index], tempCommentCount);
      }
    } else if (firebaseUpdateType === "removed") {
      let index = commentCount.value.findIndex(
        (x) => x._id === tempCommentCount._id
      );
      if (index !== -1) {
        commentCount.value.splice(index, 1);
      }
    }
  };

  const addRepostCount = (
    activityData: ActivityDataModel,
    firebaseUpdateType: string
  ) => {
    let tempRepostCount = new RepostCountModel();
    Object.assign(tempRepostCount, activityData.data);
    tempRepostCount._id = activityData.data._id;
    if (firebaseUpdateType === "added") {
      repostCount.value.push(tempRepostCount);
    } else if (firebaseUpdateType === "modified") {
      let index = repostCount.value.findIndex(
        (x) => x._id === tempRepostCount._id
      );
      if (index !== -1) {
        Object.assign(repostCount.value[index], tempRepostCount);
      }
    } else if (firebaseUpdateType === "removed") {
      let index = repostCount.value.findIndex(
        (x) => x._id === tempRepostCount._id
      );
      if (index !== -1) {
        repostCount.value.splice(index, 1);
      }
    }
  };

  const addPostsToFeed = (
    activityData: ActivityDataModel,
    firebaseUpdateType: string,
    atFirst: boolean = false
  ) => {
    let tempPost = new PostsModel();
    Object.assign(tempPost, activityData.data);
    tempPost._id = activityData.data._id;
    tempPost.domain = PostDomain.stock;
    tempPost.color = tempPost.getColor();
    tempPost.initializeReactionsFromEmbeddedData();
    if (typeof activityData.data.chart.data == "string") {
      tempPost.chart!.data = JSON.parse(activityData.data.chart.data);
    }
    if (firebaseUpdateType === "added") {
      if (posts.value.findIndex((x) => x._id == tempPost._id) == -1) {
        if (atFirst) {
          posts.value.unshift(tempPost);
        } else {
          posts.value.push(tempPost);
        }
      }
    } else if (firebaseUpdateType === "modified") {
      let index = posts.value.findIndex((x) => x._id === tempPost._id);
      if (index !== -1) {
        Object.assign(posts.value[index], tempPost);
      }
    } else if (firebaseUpdateType === "removed") {
      let index = posts.value.findIndex((x) => x._id === tempPost._id);
      if (index !== -1) {
        posts.value.splice(index, 1);
      }
    }
    posts.value.sort((a, b) => a.modifiedOn! - b.modifiedOn!);
  };

  const syncPostUserReaction = (post: PostsModel) => {
    if (!post._id) return;

    const reactionType = reactionStore.getUserReactionType(post._id, "post");
    post.userHasReacted = reactionStore.hasUserReacted(post._id, "post");

    const currentUserId = storageService.getUser()?._id;
    if (currentUserId) {
      post.userReactions =
        post.userReactions?.filter((r) => r.userId !== currentUserId) || [];
      if (reactionType) {
        post.userReactions.push({ userId: currentUserId, reactionType });
      }
    }
  };

  const addReactionCountToFeed = (
    activityData: ActivityDataModel,
    firebaseUpdateType: string
  ) => {
    let tempReactionCount = new ReactionCountModel();
    Object.assign(tempReactionCount, activityData.data);
    tempReactionCount._id = activityData.data._id;
    delete (tempReactionCount as any).userIds;

    if (firebaseUpdateType === "added") {
      reactionCount.value.push(tempReactionCount);
    } else if (firebaseUpdateType === "modified") {
      let index = reactionCount.value.findIndex(
        (x) =>
          x.sourceId === tempReactionCount.sourceId &&
          x.sourceType === tempReactionCount.sourceType
      );
      if (index !== -1) {
        Object.assign(reactionCount.value[index], tempReactionCount);
      }
    } else if (firebaseUpdateType === "removed") {
      let index = reactionCount.value.findIndex(
        (x) => x._id === tempReactionCount._id
      );
      if (index !== -1) {
        reactionCount.value.splice(index, 1);
      }
    }

    const postIndex = posts.value.findIndex(
      (post) => post._id === tempReactionCount.sourceId
    );
    if (postIndex !== -1) {
      const reactionData = { ...activityData.data };
      delete reactionData.userIds;
      posts.value[postIndex].updateFromReactionCountModel(reactionData);
      syncPostUserReaction(posts.value[postIndex]);
    }
  };

  const voteOnPollChart = async (data: any) => {
    addToPollCount(data);
    const response = await httpService.votePollStock(data);
    if (!response.data.isSuccess) {
      let index = pollCount.value.findIndex((x) => x.postId === data.postId);
      if (index != -1) {
        pollCount.value.splice(index, 1);
      }
    }
    return response;
  };

  const addToPollCount = (data: any) => {
    let tempPollCount = new PollCountModel();
    tempPollCount.postId = data.postId;
    tempPollCount.sourceId = data.postId;
    tempPollCount.sourceType = "post";
    tempPollCount.userIds = [{ userId: data.userId, stockId: data.stockId }];
    tempPollCount.count = tempPollCount.userIds.length;
    let index = pollCount.value.findIndex(
      (x) => x.postId === tempPollCount.postId
    );
    if (index === -1) {
      pollCount.value.push(tempPollCount);
    } else {
      pollCount.value[index] = { ...tempPollCount };
    }
  };

  const getPollCountByPost = (postId: string): PollCountModel | null => {
    let index = pollCount.value.findIndex((x) => x.postId === postId);
    if (index === -1) {
      return null;
    } else {
      return pollCount.value[index];
    }
  };

  const fetchPostForPage = (symbol: string) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      if (!noDataFound.value) {
        getPosts(symbol, currentPage.value + 1);
      }
    }, 200);
  };

  const handleScroll = (symbol: string, isSidemenuShown: boolean, elemId: string, sideMenuId: string, tries: number = 0) => {
    let elem: any = document.getElementById(sideMenuId);
    if (!elem) {
      elem = document.getElementById(elemId);
    }
    if (elem) {
      elem.onscroll = (ev: any) => {
        const scrollPosition = elem.scrollTop + elem.clientHeight;
        const threshold = 200;
        if (scrollPosition >= elem.scrollHeight - threshold) {
          fetchPostForPage(symbol);
        }
      };
    } else if (tries < 5) {
      setTimeout(() => {
        handleScroll(symbol, isSidemenuShown, elemId, sideMenuId, tries);
      }, 500);
    }
  };

  const addPostToStockCollections = async (postId: any) => {
    let info = {
      postId: postId,
      feedId: stockName.value,
    }
    let response = await httpService.addPostToStockCollections(info);
    if (response) {}
  }

  return {
    stockName,
    addPostToFeeding,
    getPosts,
    clearPosts,
    addPost,
    addPostsToFeed,
    updatePost,
    voteOnPollChart,
    posts,
    reactionCount,
    deletePost,
    commentCount,
    getPostById,
    repostCount,
    pollCount,
    getPollCountByPost,
    showLoader,
    noDataFound,
    currentPage,
    handleScroll,
  };

};
